import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/subjects';

export async function query(): Promise<Record<string, any>[]> {
	const response: Response = await BBApi.get(rootUrl);

	if (response.ok === false) {
		throw new Error('cant get subjects');
	}

	const subjects: Record<string, any>[] = await response.json();
	return subjects;
}

export async function get(id: string): Promise<Record<string, any>> {
	const response: Response = await BBApi.get(rootUrl + `/${id}`);

	if (response.ok === false) {
		throw new Error('cant get subject');
	}

	const subject: Record<string, any> = await response.json();
	return subject;
}

export async function create(subject: Record<string, any>): Promise<string> {
	const response: Response = await BBApi.post(rootUrl, subject);

	if (response.ok === false) {
		throw new Error('cant create subject');
	}

	const { subjectId }: { subjectId: string } = await response.json();
	return subjectId;
}

export async function update(id: string, subject: Record<string, any>): Promise<void> {
	const response: Response = await BBApi.put(rootUrl + `/${id}`, subject);

	if (response.ok === false) {
		throw new Error('cant update subject');
	}
}

export async function remove(id: string): Promise<void> {
	const response: Response = await BBApi.del(rootUrl + `/${id}`);

	if (response.ok === false) {
		throw new Error('cant delete subject');
	}
}

export async function validateId(subjectId: string): Promise<void> {
	const response: Response = await BBApi.post(rootUrl + '/validate-id', { subjectId });

	if (response.ok === false) {
		throw new Error('invalid subject title');
	}
}
